import RequestAbstract from "./RequestAbstract";

export default class Support extends RequestAbstract {
  get link() {
    return "support";
  }

  /**
   * Send a support ticket with optional screenshots.
   * @param {FormData} formData – contains topic, message, screenshot_N fields
   * @returns {Promise<object>} API response
   */
  async send(formData) {
    return await this.loadWithAuth(
      this.link + "/ticket",
      {
        method: "POST",
        body: formData,
      },
      false, // do not set Content-Type (let browser set multipart boundary)
    );
  }
}
